import React from 'react';

import { Section } from '@gogame/components';

import { useExtraContext } from 'scenes/SmartRules/SmartRuleForm/ExtraContext';

import { PopulationCustomize } from './PopulationCustomize';

export const PopulationCustomizeSection = () => {
  const { hasDynamicConditions } = useExtraContext();

  if (!hasDynamicConditions) {
    return null;
  }

  return (
    <Section
      prompt={` Update Dynamic Conditions population in case you wish it will be
            different than the general results population`}
      title={'Dynamic Conditions Population'}
    >
      <PopulationCustomize />
    </Section>
  );
};
